import React, { useCallback, useEffect, useState,useMemo, forwardRef, useImperativeHandle } from "react";
import { Button, Text, Input, HelperText, Icon } from "@ui-component-library";
import { validateEmail, formattedPhoneNumber } from "../../../components/login/helpers";
import { isValidPhoneNumber } from 'react-phone-number-input';

const IdentificationStep = forwardRef(({ onNext, isLoggedIn, formData: parentFormData }, ref) => {
    const [errors, setErrors] = useState({})
    const [formData, setFormData] = useState(parentFormData||{userData:{}})
    const [userName, setUserName] = useState({})

    useEffect(() => {
        if (Window.user_data.isLogged) {
            if ((Window.user_data.name).includes(" ")) {
                const parts = Window.user_data.name.split(" ");
                setUserName({ firstname: parts[0], surname: parts.slice(1).join(" ") })
            } else if (Window.user_data.name.includes("@")) {
                setUserName({})
            } else {
                setUserName({ firstname: Window.user_data.name })
            }
        }

    }, [])

    useImperativeHandle(ref, () => ({
        validateAndReturn() {
            const validation = validate();

            if (Object.keys(validation).length > 0) {
                setErrors(validation);
                return { errors: validation };
            }

            return {
                data: {
                    userData: finalUserData,
                    step: "treeform_user_identification",
                }
            };
        }
    }));


    const handleChange = useCallback((key, value) => {

        setFormData(prev => ({
        ...prev, userData: {...prev.userData, [key]: value }
    }));

        setErrors(prevErrors => {

            const newErrors = { ...prevErrors };
            if (newErrors.hasOwnProperty(key)) {
                delete newErrors[key];
            }

            return newErrors;
        });
    }, []);

    const finalUserData = useMemo(() => {
        const baseData = {
            firstname: formData.userData?.firstname || userName.firstname || '',
            surname: formData.userData?.surname || userName.surname || '',
        };
        if (isLoggedIn) {
            return baseData;
        }

        return {
            ...baseData,
            email: formData.userData?.email || '',
            mobilePhoneNumber: formData.userData?.mobilePhoneNumber || '',
        };
    }, [formData, userName, isLoggedIn]);

    const validate = useCallback(() => {
        const validation = {};

        if (!finalUserData.firstname) {
            validation.firstname = "Fyll i detta obligatoriska fält (Förnamn).";
        }

        if (!finalUserData.surname) {
            validation.surname = "Fyll i detta obligatoriska fält (Efternamn).";
        }
        
        if (finalUserData.email && !validateEmail(finalUserData.email)) {
             validation.email = "Ogiltig e-postadress.";
        } else if (!finalUserData.email && !isLoggedIn) {
            validation.email = "Fyll i detta obligatoriska fält (E-post).";
        }

        const phoneNumberValue = String(finalUserData.mobilePhoneNumber || '');

        if (!phoneNumberValue && !isLoggedIn) {
            validation.mobilePhoneNumber = "Fyll i detta obligatoriska fält (Telefonnummer).";
        } 
        
        else if (phoneNumberValue) {
            try {
                const formatted = formattedPhoneNumber(phoneNumberValue); 
                
                if (!isValidPhoneNumber(formatted)) {
                    validation.mobilePhoneNumber = "Ogiltig telefonnummer.";
                }else{
                    finalUserData["mobilePhoneNumber"] = formatted
                }

            } catch (error) {
                console.error("Phone Validation Library Failed:", error); 
                validation.mobilePhoneNumber = "Ogiltig telefonnummer.";
            }
            
        }

        return validation;
    }, [finalUserData, isLoggedIn]);

    const handleSubmit = useCallback((e) => {
        e.preventDefault(); 
        
        const validation = validate();

        if (Object.keys(validation).length > 0) {
            setErrors(validation);
            return;
        }
        
        setErrors({});
        onNext({
            data: {
                userData:finalUserData, 
                step: "treeform_user_identification"
            }
        });

    }, [validate, onNext, finalUserData]);

    return (
        <form onSubmit={handleSubmit} className="h-full flex flex-col justify-center items-center">
            <div className="w-full md:w-[500px] px-10 grid grid-row gap-4">
                <Text variant="text-xl/leading-normal/normal" className="text-white">1. Ange dina kontaktuppgifter?</Text>
                {!userName?.firstname && <div>
                    <Input
                        tw
                        label="Förnamn"
                        name="firstname"
                        onChange={(val) => handleChange('firstname', val)}
                        type="text"
                        variant="fluid"
                        value={finalUserData?.firstname}
                    />
                    {errors?.firstname && <HelperText className='text-danger-500 fill-danger-500 justify-center mt-2' icon='ExclamationFilled' label={errors.firstname} />}
                </div>}
                {!userName?.surname && <div>
                    <Input
                        tw
                        label="Efternamn"
                        name="surname"
                        onChange={(val) => handleChange('surname', val)}
                        type="text"
                        variant="fluid"
                        value={finalUserData?.surname}
                    />
                    {errors?.surname && <HelperText className='text-danger-500 fill-danger-500 justify-center mt-2' icon='ExclamationFilled' label={errors.surname} />}
                </div>}
                {!isLoggedIn && <div>
                    <Input
                        tw
                        label="E-post"
                        name="email"
                        onChange={(val) => handleChange('email', val)}
                        type="email"
                        variant="fluid"
                        value={finalUserData?.email}
                    />
                    {errors?.email && <HelperText className='text-danger-500 fill-danger-500 justify-center mt-2' icon='ExclamationFilled' label={errors.email} />}
                </div>}
                {!isLoggedIn || !Window.user_data.mobilePhoneNumber ? <div>
                    <Input
                        tw
                        label="Telefonnummer"
                        name="mobilePhoneNumber"
                        onChange={(val) => handleChange('mobilePhoneNumber', val)}
                        type="phone"
                        variant="fluid"
                        value={finalUserData?.mobilePhoneNumber}
                    />
                    {errors?.mobilePhoneNumber && <HelperText className='text-danger-500 fill-danger-500 justify-center mt-2' icon='ExclamationFilled' label={errors.mobilePhoneNumber} />}
                </div> : <Text variant="text-sm/leading-normal/normal" className="text-white">Telefonnummer: {Window.user_data.mobilePhoneNumber}</Text>}


            </div>
            <div className="fixed bottom-0 left-0 w-full sm:static sm:w-auto sm:h-auto sm:flex sm:justify-center sm:items-center mt-4">
                <div className="flex justify-center items-center py-4 px-2 sm:py-0">
                    <Button
                        tw
                        onClick={handleSubmit}
                        variant="quaternary"
                        fullWidth
                        type="submit"
                        disabled={Object.keys(errors).length > 0}
                    >
                        Nästa
                        <Icon
                            className="fill-charcoal-500"
                            name="ArrowRightSimple"
                            size="large"
                        />
                    </Button>
                </div>
            </div>
        </form>
    )
});

export default IdentificationStep;